import { createRouter, createWebHashHistory } from "vue-router";
import TrackAndTrace from "../components/views/TrackAndTrace.vue";
import TrackAndTraceList from "../components/views/TrackAndTraceList.vue";
import AnixterTrace from "../components/views/TrackAndTraceAnixter.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: TrackAndTraceList,
  },
  {
    path: "/TrackAndTrace",
    name: "TrackAndTraceList",
    component: TrackAndTraceList,
  },
  {
    path: "/TrackAndTrace/detail/:KeyValue",
    name: "TrackAndTrace",
    component: TrackAndTrace,
  },
    {
        path: "/AnixterTrace/detail/:ProNo",
        name: "AnixterTrace",
        component: AnixterTrace,
    }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router;
